/* eslint-disable no-script-url */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Button } from 'homecredit-ui';
import classnames from 'classnames';
import { sendGAEvent } from 'utils/ga';
import { getBrowserName, getOperatingSystem } from 'utils/operation';
import s from './CallButton.css';
import iconCall from './images/call.svg';
import { ACL0BOD_HOTLINE } from './constant';

class CallButton extends Component {
  state = {
    isShowingHotLine: false,
  };

  handleShowModal = () => {
    this.setState({ isShowingHotLine: true });
    this.trackingCallButton();
  };

  handleCloseModal = () => {
    this.setState({ isShowingHotLine: false });
  };

  trackingCallButton = () => {
    sendGAEvent('Click_call_hotline', 'Hotline', 'Hotline');
  };

  render() {
    const { className } = this.props;
    const { isShowingHotLine } = this.state;
    const isFox = getBrowserName() === 'Firefox';
    const isDroid = getOperatingSystem() === 'Android';
    const isDroidFox = isDroid && isFox;
    const aProps = {
      href: isDroidFox ? 'javascript:void(0);' : `tel:${ACL0BOD_HOTLINE}`,
      className: classnames(s.welcomeXs, className),
      onClick: isDroidFox ? this.handleShowModal : this.trackingCallButton,
    };

    return (
      <>
        <a {...aProps}>
          <div className={s.phone}>
            <img src={iconCall} alt="call button" />
          </div>
        </a>
        <div
          className={classnames(s.welcome, className)}
          onClick={this.handleShowModal}
        >
          <div className={s.phone}>
            <img src={iconCall} alt="call button" />
          </div>
        </div>

        {isShowingHotLine && (
          <div className={s.backdrop}>
            <div className={s.modalContent}>
              <span>
                Hãy gọi
                <a
                  href={`tel:${ACL0BOD_HOTLINE}`}
                  className={s.hotNumber}
                >{` ${ACL0BOD_HOTLINE} `}</a>
                để được hướng dẫn thêm!
              </span>
              <Button
                stretch
                className={s.closeModalButton}
                onClick={this.handleCloseModal}
              >
                Đóng
              </Button>
            </div>
          </div>
        )}
      </>
    );
  }
}

CallButton.propTypes = {
  className: PropTypes.string,
};

CallButton.defaultProps = {
  className: '',
};

export default withStyles(s)(CallButton);
